import React from 'react'
import { ActionSuggestion } from './model'
import { getUserDisplayName } from '../../apps/professional-app/fa/common/aifeatures/utils'
import { INTEGRATION_DISPLAY_NAME_MAP, IntegrationServiceId } from '../../common/integrations'

const ServiceName: React.FC<{ serviceId: IntegrationServiceId }> = ({ serviceId }) => {
  const name = INTEGRATION_DISPLAY_NAME_MAP[serviceId]
  return name ? <span>{name}</span> : <span className='text-capitalize'>{serviceId}</span>
}

export const ActionTitle: React.FC<{ actionSuggestion: ActionSuggestion }> = ({ actionSuggestion }) => {
  const getExportTitle = (actionSuggestion: ActionSuggestion) => {
    switch (actionSuggestion.actionType) {
      case 'createTask':
        return (
          <div>
            Save <b>'Tasks'</b> to <ServiceName serviceId={actionSuggestion.serviceId} />
          </div>
        )
      case 'exportMeeting':
        return (
          <div>
            Save <b>'Meeting Summary'</b> to <ServiceName serviceId={actionSuggestion.serviceId} />
          </div>
        )
      case 'updateContact':
        return (
          <div>
            Update <b>'{getUserDisplayName(actionSuggestion.user, 'Contact')}'</b> in <ServiceName serviceId={actionSuggestion.serviceId} />
          </div>
        )
    }
  }

  return <>{getExportTitle(actionSuggestion)}</>
}
